/**
 * Danger Zone Entry Effect for Sector-Landing Template
 * Creates a cinematic sector entry with impact, klaxons, and alert aesthetics
 */

export function startDangerZoneEffect(containerEl) {
  if (!containerEl) return () => {};

  const timeouts = [];
  const intervals = [];

  // Find elements
  const sectorTitle = containerEl.querySelector('.sector-title');
  const alertBorder = containerEl.querySelector('.alert-border');
  const statsOverlay = containerEl.querySelector('.sector-stats-overlay');
  const contentLines = containerEl.querySelectorAll('.sector-content-line');
  const warningFlash = containerEl.querySelector('.warning-flash');

  // 1. Initial warning flash
  if (warningFlash) {
    warningFlash.classList.add('active');
    timeouts.push(setTimeout(() => {
      warningFlash.classList.remove('active');
    }, 300));
  }

  // 2. Sector title impact (150ms)
  if (sectorTitle) {
    timeouts.push(setTimeout(() => {
      sectorTitle.classList.add('impact');
    }, 150));
  }

  // 3. Alert border pulse (300ms)
  if (alertBorder) {
    timeouts.push(setTimeout(() => {
      alertBorder.classList.add('active');
    }, 300));
  }

  // 4. Stats overlay reveal (600ms)
  if (statsOverlay) {
    timeouts.push(setTimeout(() => {
      statsOverlay.classList.add('visible');
    }, 600));
  }

  // 5. Content lines stagger reveal (800ms+)
  if (contentLines && contentLines.length > 0) {
    contentLines.forEach((line, index) => {
      timeouts.push(setTimeout(() => {
        line.classList.add('visible');
      }, 800 + (index * 150)));
    });
  }

  // 6. Klaxon pulse effect (continuous)
  if (alertBorder) {
    const pulseInterval = setInterval(() => {
      alertBorder.classList.add('pulse');
      setTimeout(() => {
        alertBorder.classList.remove('pulse');
      }, 200);
    }, 2000);
    
    intervals.push(pulseInterval);
  }

  // Cleanup
  return () => {
    timeouts.forEach((id) => clearTimeout(id));
    intervals.forEach((id) => clearInterval(id));
  };
}
